import React from "react";
import { footerIcons } from "../constants";
import { FooterList } from "./smComponents/FooterList";

export const Footer = () => {
  return (
    <div className="footer-cg max-width">
      <div className="footer-bg  mw-ct">
        <div className="wr-cg-6">
          {footerIcons.map(({ id }) => {
            return (
              <span className="cgi-8-footer" key={id}>
                <span className={`f${id}`} alt="fa"></span>
              </span>
            );
          })}
        </div>
        <FooterList />
      </div>
    </div>
  );
};
export default Footer;
